import { VisitSettlementAdjustment } from '@dreryk/egabinet-financial-settlement-frontend-api';

import { EmptyStatePlaceholder, StyledMargin } from '@dreryk/react-components';

import { AdjustmentDataText } from '../../../../shared/adjustment/AdjustmentDataText';
import { visitSettlementTranslationKeys } from '../../../../translations';

type MedicalServicesTableEmptyStatePlaceholderProps = {
   readonly adjustment: VisitSettlementAdjustment | undefined;
};

export const MedicalServicesTableEmptyStatePlaceholder = (
   props: MedicalServicesTableEmptyStatePlaceholderProps
): JSX.Element => {
   return (
      <>
         <EmptyStatePlaceholder
            testId={'noMedicalServices'}
            heading={visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.noMedicalServices}
            subheading={
               visitSettlementTranslationKeys.extensions.visitHistory.medicalServicesTab.noMedicalServicesSpecified
            }
         />
         {props.adjustment ? (
            <StyledMargin top={8}>
               <AdjustmentDataText
                  author={`${props.adjustment.adjustedBy.firstName} ${props.adjustment.adjustedBy.lastName}`}
                  date={props.adjustment.adjustmentDate}
               />
            </StyledMargin>
         ) : null}
      </>
   );
};
